import {ReplaySubject} from 'rxjs';

export interface ToastDescription {
    text: string;
    type: Type;
}

export class Toaster {
    // TODO Make these private and provide methods to subscribe to these
    public static toastDescription = new ReplaySubject<ToastDescription>();

    public static toast(text: string, type?: Type): void {
        this.toastDescription.next({text, type});
    }
}

export enum Type {
    NonDismissibleAlert = 'NonDismissibleAlert',
    Success = 'Success',
    Error = 'Error',
    Alert = 'Alert',
}